/* =============================================
   TP — Roleta Black (v2) — pop-up com o visual verde e a mecânica da roleta do site.

   Igual ao tp-roleta.js (v1) em tudo o que importa: lista de bloqueio por caminho e
   por UTM, chave da campanha (tp-roleta-campanha), prêmio guardado no localStorage,
   aba lateral, presente registrado em tp-roleta-presente* (quem põe e tira do
   carrinho é o tp-presente.js), cupom aplicado por /discount/.

   O QUE MUDA (20/10/2026, Black Antecipada):
   - NÃO pede e-mail: roda parou -> presente registrado -> pop-up "presente ganho"
     2 s depois (window.tpPresenteGanho, de tp-presente.js).
   - Funciona para quem JÁ COMPROU: não existe a trava de primeira compra.
   - Desenho das fatias: legenda pequena + valor grande, roda toda verde com a fatia
     em destaque em sálvia (tp-e-roleta-v2.liquid). Nada de fitLabels: o texto é curto
     e fixo.

   Expõe window.tpRoletaV2.abrir() para a seção da oferta na coleção poder abrir o
   pop-up (quem já ganhou revê o prêmio).
   ============================================= */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var POINTER = 90; // ponteiro à direita (3h); 0 = topo, sentido horário
  var R = 89;       // raio das fatias (o aro vai até 92)
  var RC = 56;      // raio do centro dos textos

  function normalizePath(p) {
    p = (p || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    var m = p.match(/^\/[a-z]{2}(?:-[a-z]{2})?(\/collections\/.*)$/i);
    return (m ? m[1] : p).toLowerCase();
  }
  function brlRoleta(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function notaPresente(minimo) {
    var cents = Math.round((+minimo || 0) * 100);
    return cents > 0 ? 'Vai junto em compras acima de ' + brlRoleta(cents).replace(/,00$/, '') : 'Vai junto no seu pedido';
  }
  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function currentAngle(el) {
    var tr = getComputedStyle(el).transform;
    if (!tr || tr === 'none') return 0;
    var m = tr.match(/matrix\(([^)]+)\)/);
    if (!m) return 0;
    var v = m[1].split(',').map(parseFloat);
    var ang = Math.atan2(v[1], v[0]) * 180 / Math.PI;
    return ang < 0 ? ang + 360 : ang;
  }
  function pt(r, deg) {
    var rad = (deg - 90) * Math.PI / 180;
    return [r * Math.cos(rad), r * Math.sin(rad)];
  }
  function el(tag, at, pai) {
    var e = document.createElementNS(NS, tag);
    for (var k in at) e.setAttribute(k, at[k]);
    pai.appendChild(e);
    return e;
  }

  function init(root) {
    if (!root || root.dataset.tpRv2Ready) return;
    root.dataset.tpRv2Ready = '1';

    var EDIT = root.dataset.edit === '1';
    var DESIGN = root.dataset.design === '1';
    var d = root.dataset;

    /* ---- Lista de bloqueio por caminho (curinga em qualquer posição, sem RegExp) ---- */
    var here = normalizePath(location.pathname);
    var bloqueios = String(root.dataset.bloqueio || '').split('\n').map(function (l) { return normalizePath(l.trim()); }).filter(Boolean);
    function casaGlob(p, s) {
      var partes = p.split('*'), pos = 0;
      for (var i = 0; i < partes.length; i++) {
        var t = partes[i];
        if (!t) continue;
        var j = s.indexOf(t, pos);
        if (j === -1) return false;
        if (i === 0 && j !== 0) return false;
        pos = j + t.length;
      }
      if (partes[partes.length - 1] !== '' && pos !== s.length) return false;
      return true;
    }
    var barrado = bloqueios.some(function (p) { return p.indexOf('*') === -1 ? here === p : casaGlob(p, here); });
    if (barrado && !DESIGN) { root.parentNode && root.parentNode.removeChild(root); return; }

    /* ---- Bloqueio por UTM (herdado da raspadinha; marca a sessão) ---- */
    var utmBloq = false;
    try { utmBloq = sessionStorage.getItem('tp-roleta-utm-bloqueio') === '1'; } catch (e) {}
    if (!utmBloq) {
      var qs = {};
      try {
        location.search.replace(/^\?/, '').split('&').forEach(function (par) {
          if (!par) return;
          var kv = par.split('=');
          qs[decodeURIComponent(kv[0]).toLowerCase()] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')).toLowerCase();
        });
      } catch (e) {}
      String(root.dataset.bloqueioUtm || '').split('\n').forEach(function (l) {
        var kv = l.trim().toLowerCase().split('=');
        if (kv.length < 2 || !kv[0]) return;
        var chave = kv[0].indexOf('utm_') === 0 ? kv[0] : 'utm_' + kv[0];
        if (qs[chave] !== undefined && qs[chave] === kv.slice(1).join('=')) utmBloq = true;
      });
      if (utmBloq) { try { sessionStorage.setItem('tp-roleta-utm-bloqueio', '1'); } catch (e) {} }
    }
    if (utmBloq && !DESIGN) { root.parentNode && root.parentNode.removeChild(root); return; }

    /* ---- Página única (quando tp-roleta-pagina não é '*') ---- */
    var pagina = String(root.dataset.pagina || '').trim().toLowerCase();
    if (pagina && pagina !== '*' && here !== '/collections/' + pagina && !DESIGN) {
      root.parentNode && root.parentNode.removeChild(root);
      return;
    }

    var KEY = root.dataset.key || 'tp-roleta-black-v1';

    /* MODO TESTE (setting modo_teste, 21/10/2026, pedido do Guilherme): a cada carregamento
       da página esquece o giro anterior E o presente guardado por ESTA campanha, e a roleta
       abre do zero. Dentro da mesma página tudo segue normal (giro guardado, tamanho,
       presente no carrinho). Só mexe nas chaves desta roleta; as outras roletas têm as suas. */
    var TESTE = root.dataset.teste === '1';
    if (TESTE) {
      try {
        localStorage.removeItem(KEY); localStorage.removeItem(KEY + ':closed');
        var campTeste = localStorage.getItem('tp-roleta-presente-campanha');
        if (!campTeste || campTeste === KEY) {
          ['tp-roleta-presente', 'tp-roleta-presente-minimo', 'tp-roleta-presente-variante', 'tp-roleta-presente-tamanho', 'tp-roleta-presente-campanha', 'tp-roleta-presente-valor'].forEach(function (k) { localStorage.removeItem(k); });
        }
      } catch (e) {}
    }

    /* Presente preso à campanha: ganho com outra chave = apagado. */
    try {
      var campanhaGravada = localStorage.getItem('tp-roleta-presente-campanha');
      if (localStorage.getItem('tp-roleta-presente') && campanhaGravada !== KEY) {
        ['tp-roleta-presente', 'tp-roleta-presente-minimo', 'tp-roleta-presente-variante', 'tp-roleta-presente-tamanho', 'tp-roleta-presente-campanha', 'tp-roleta-presente-valor'].forEach(function (k) { localStorage.removeItem(k); });
      }
    } catch (e) {}

    var DELAY = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    var TURNS = parseInt(root.dataset.turns, 10) || 5;
    var SECONDS = parseFloat(root.dataset.seconds) || 6;
    var APPLY = root.dataset.apply === '1';

    var card = root.querySelector('[data-rv2-card]');
    var wheel = root.querySelector('[data-rv2-roda]');
    var gF = root.querySelector('[data-rv2-fatias]');
    var gT = root.querySelector('[data-rv2-textos]');
    var pointer = root.querySelector('[data-rv2-ponteiro]');
    var spinBtns = root.querySelectorAll('[data-rv2-girar]');
    var spinBtn = spinBtns[spinBtns.length - 1];
    function eachSpin(fn) { for (var b = 0; b < spinBtns.length; b++) fn(spinBtns[b]); }
    var result = root.querySelector('[data-rv2-result]');
    var wonLabel = root.querySelector('[data-rv2-premio]');
    var descEl = root.querySelector('[data-rv2-desc]');
    var codeWrap = root.querySelector('[data-rv2-code-wrap]');
    var codeEl = root.querySelector('[data-rv2-code]');
    var copyBtn = root.querySelector('[data-rv2-copy]');
    var codeStep = root.querySelector('[data-rv2-code-step]');
    var presenteStep = root.querySelector('[data-rv2-presente-step]');
    var presenteFoto = root.querySelector('[data-rv2-presente-foto]');
    var presenteNome = root.querySelector('[data-rv2-presente-nome]');
    var presenteNota = root.querySelector('[data-rv2-presente-nota]');
    var presenteTamBtn = root.querySelector('[data-rv2-presente-tamanho]');
    var noteStep = root.querySelector('[data-rv2-note-step]');
    var ctaBtn = root.querySelector('[data-rv2-cta]');
    var confetti = root.querySelector('[data-rv2-confete]');
    var closeEls = root.querySelectorAll('[data-rv2-fechar]');
    var stage = root.querySelector('.tp-rv2__stage');
    var WHEEL_MAX = parseInt(root.dataset.wheel, 10) || 400;

    /* O CARD CABE NA TELA, SEMPRE (21/10/2026, reenviado 2x para o sync; Guilherme: "proibido scroll dentro do pop-up").
       Mede o card com a roda no tamanho natural, tira a roda da conta e dá a ela só o que sobra
       da altura da janela (menos 32px de margem). Antes de girar a roda nunca fica menor que
       140px; depois do giro, se nem 150px couberem, a roda some e fica só o resultado. */
    var caberTimer = 0;
    function caber() {
      if (!stage || !card || !root.classList.contains('is-visible')) return;
      var avail = (window.innerHeight || document.documentElement.clientHeight || 0) - 32;
      if (avail <= 0) return;
      stage.style.width = ''; stage.style.paddingBottom = ''; stage.classList.remove('is-oculta');
      /* CORREÇÃO 21/10/2026 (print do Guilherme no celular: roda grande + resultado cortado, sem rolar):
         o tamanho em linha passava por cima das regras do CSS copiadas da v1 (depois do giro, no
         celular, a roda é de 190px; em tela até 700px de altura ela some). Agora o CSS dá o teto:
         o JS só ENCOLHE a partir dele, nunca cresce. cssW = 0 significa que o CSS já tirou a roda. */
      var cssW = stage.offsetWidth;
      if (!cssW) return;
      var cs = getComputedStyle(card);
      var contentW = card.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      var outros = card.scrollHeight - stage.offsetHeight;
      var size = Math.min(WHEEL_MAX, cssW, contentW, avail - outros - 2);
      if (done && size < 150) { stage.classList.add('is-oculta'); return; }
      size = Math.max(140, Math.floor(size));
      if (size >= cssW) return;
      stage.style.width = size + 'px';
      stage.style.paddingBottom = size + 'px';
    }
    function caberLogo() { clearTimeout(caberTimer); caber(); caberTimer = setTimeout(caber, 60); }
    window.addEventListener('resize', caberLogo);
    window.addEventListener('orientationchange', caberLogo);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(caberLogo).catch(function () {});
    /* O resultado muda de altura depois do giro (cartão do presente, chip "Tamanho escolhido", foto):
       cada mudança remede. Sem ResizeObserver (navegador velho), os eventos abaixo cobrem o grosso. */
    if (window.ResizeObserver && result) new ResizeObserver(function () { caberLogo(); }).observe(result);
    if (presenteFoto) presenteFoto.addEventListener('load', caberLogo);

    function tamanhoEscolhido() { try { return localStorage.getItem('tp-roleta-presente-tamanho'); } catch (e) { return null; } }
    var premioSemTamanho = false;
    function presenteSemTamanho() { return premioSemTamanho || tamanhoEscolhido() === 'unico'; }
    function atualizaTamanho() {
      if (!presenteTamBtn) return;
      if (presenteSemTamanho()) { presenteTamBtn.hidden = true; return; }
      var t = tamanhoEscolhido();
      presenteTamBtn.hidden = false;
      /* Com tamanho: "Tamanho G | ✎ trocar" — o "trocar" explícito é para a cliente mais velha entender que
         dá para mudar (21/10/2026, Guilherme). Sem tamanho: texto simples. */
      if (t) {
        presenteTamBtn.innerHTML = '<span>Tamanho <b></b></span><span class="tp-rv2__presente-trocar"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 3.5l3 3L7 16H4v-3z"/><path d="M11.5 5.5l3 3"/></svg>trocar</span>';
        presenteTamBtn.querySelector('b').textContent = String(t).split(' (')[0];
        presenteTamBtn.setAttribute('aria-label', 'Tamanho ' + String(t).split(' (')[0] + ' escolhido. Trocar o tamanho');
      } else { presenteTamBtn.textContent = 'Escolher o tamanho do presente'; presenteTamBtn.removeAttribute('aria-label'); }
      presenteTamBtn.classList.toggle('is-ok', !!t);
      caberLogo();
    }
    if (presenteTamBtn) presenteTamBtn.addEventListener('click', function () { if (window.tpPresenteTamanho) window.tpPresenteTamanho.abrir(); });
    document.addEventListener('tp:presente-tamanho', atualizaTamanho);

    var prizes = [];
    try { prizes = JSON.parse(root.querySelector('[data-rv2-premios]').textContent) || []; } catch (e) { prizes = []; }
    var N = prizes.length;
    if (N < 2) return;
    var SEG = 360 / N;

    /* ---- Desenho: fatia + legenda + valor (metade esquerda nasce virada) ---- */
    var fatiaEls = [], textoEls = [];
    function orienta(g, virado) {
      var mid = parseFloat(g.dataset.mid);
      var rot = virado ? mid + 90 : mid - 90;
      g.setAttribute('transform', 'translate(' + g.dataset.cx + ' ' + g.dataset.cy + ') rotate(' + rot.toFixed(3) + ')');
    }
    prizes.forEach(function (p, i) {
      var a0 = i * SEG, a1 = a0 + SEG, mid = a0 + SEG / 2;
      var p0 = pt(R, a0), p1 = pt(R, a1);
      var cor = p.destaque ? d.corDestaque : (i % 2 ? d.corB : d.corA);
      fatiaEls.push(el('path', {
        'class': 'tp-rv2__slice',
        d: 'M0 0 L' + p0[0].toFixed(3) + ' ' + p0[1].toFixed(3) + ' A' + R + ' ' + R + ' 0 ' + (SEG > 180 ? 1 : 0) + ' 1 ' + p1[0].toFixed(3) + ' ' + p1[1].toFixed(3) + ' Z',
        fill: cor, stroke: d.corAro, 'stroke-width': 0.7
      }, gF));
      var c = pt(RC, mid);
      var g = el('g', { 'class': 'tp-rv2__label' }, gT);
      g.dataset.mid = mid;
      g.dataset.cx = c[0].toFixed(3);
      g.dataset.cy = c[1].toFixed(3);
      orienta(g, mid > 180);
      var cap = el('text', { 'class': 'tp-rv2__cap', x: 0, y: -5.6, 'text-anchor': 'middle', fill: p.destaque ? d.corTintaDestaque : d.corLegenda }, g);
      cap.textContent = p.legenda || '';
      var val = el('text', { 'class': 'tp-rv2__val', x: 0, y: 5.8, 'text-anchor': 'middle', fill: p.destaque ? d.corTintaDestaque : d.corValor }, g);
      val.textContent = p.valor || '';
      textoEls.push(g);
    });

    /* ---- Já viu? (fora do modo edição) ---- */
    var fechouAntes = false;
    var premioAtual = null;
    var premioGuardado = null;
    if (!EDIT) {
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
      if (saved && saved.t) premioGuardado = saved;
      /* AUTOCURA DO PRESENTE (22/10/2026, caso do Guilherme: "roleta girada, tamanho escolhido, carrinho diz gire a
         roleta"). Nas primeiras horas da campanha a Shopify ainda serve páginas em cache com o HTML ANTIGO, que
         carrega a roleta antiga do site (tp-roleta.js, chave site-v1); o script dela, ao ver um presente gravado
         com a chave da Black, apaga as chaves tp-roleta-presente* -- mas não este prêmio guardado. Aqui, se o prêmio
         está guardado e a chave do presente sumiu, o presente é regravado a partir do prêmio. O tamanho escolhido
         se perde junto; o pop-up de tamanho volta a pedir quando o carrinho passar do mínimo. */
      if (premioGuardado && premioGuardado.presente) {
        var temPresente = null;
        try { temPresente = localStorage.getItem('tp-roleta-presente'); } catch (e) {}
        if (!temPresente) guardaPresente(premioGuardado.presente, premioGuardado.presenteMinimo, premioGuardado);
      }
      /* GIROU = NUNCA MAIS ABRE SOZINHA (27/10/2026, Guilherme: "a roleta está abrindo quando não devia").
         Saiu o "comprou -> gira de novo" de 22/10: ele lia "token do carrinho mudou + carrinho vazio" como
         compra, mas o token também muda quando o cookie do carrinho é trocado sem compra (expirou, saiu da
         conta, limpou cookies) -- e aí a roleta apagava o giro e o presente e abria de novo. Agora o giro
         fica guardado de vez; a roleta só volta pela aba. */
      if (premioGuardado) premioSemTamanho = !!premioGuardado.presenteSemTamanho;
      var dismissed = null;
      try { dismissed = localStorage.getItem(KEY + ':closed'); } catch (e) { dismissed = null; }
      if (dismissed) fechouAntes = true;
    }

    function rememberSpin(extra) {
      if (EDIT) return;
      try { localStorage.setItem(KEY, JSON.stringify(Object.assign({ t: Date.now() }, extra || {}))); } catch (e) {}
    }
    function rememberClose() {
      if (EDIT) return;
      try { localStorage.setItem(KEY + ':closed', '1'); } catch (e) {}
    }

    /* ---- Sorteio pelo peso ---- */
    function pick() {
      var total = 0, i;
      for (i = 0; i < N; i++) total += Math.max(0, +prizes[i].weight || 0);
      if (total <= 0) return Math.floor(Math.random() * N);
      var r = Math.random() * total;
      for (i = 0; i < N; i++) { r -= Math.max(0, +prizes[i].weight || 0); if (r < 0) return i; }
      return N - 1;
    }

    /* ---- Ponteiro tica a cada fatia ---- */
    var tickRaf = 0, lastIdx = -1;
    function sliceUnderPointer(angle) { return Math.floor(((((POINTER - angle) % 360) + 360) % 360) / SEG) % N; }
    function tickLoop() {
      var idx = sliceUnderPointer(currentAngle(wheel));
      if (idx !== lastIdx) {
        if (lastIdx !== -1) {
          pointer.classList.add('is-tick');
          setTimeout(function () { pointer.classList.remove('is-tick'); }, 60);
          try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) {}
        }
        lastIdx = idx;
      }
      tickRaf = requestAnimationFrame(tickLoop);
    }

    /* ---- Confete na paleta ---- */
    var PALETA = [d.corLegenda, d.corDestaque, d.corA, '#F1F0EB'];
    function burst() {
      if (!confetti || reducedMotion()) return;
      var ctx = confetti.getContext('2d');
      if (!ctx) return;
      var dpr = window.devicePixelRatio || 1;
      var W = card.clientWidth, H = card.clientHeight;
      confetti.width = W * dpr; confetti.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var sr = wheel.getBoundingClientRect(), cr = card.getBoundingClientRect();
      var ox = sr.left - cr.left + sr.width / 2, oy = sr.top - cr.top;
      var parts = [];
      for (var i = 0; i < 56; i++) {
        var a = (-90 + (Math.random() - 0.5) * 150) * Math.PI / 180, sp = 5 + Math.random() * 7;
        parts.push({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, w: 4 + Math.random() * 4, h: 6 + Math.random() * 6, rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, c: PALETA[i % PALETA.length] });
      }
      var start = performance.now(), DUR = 1700;
      function frame(now) {
        var t = (now - start) / DUR;
        ctx.clearRect(0, 0, W, H);
        if (t >= 1) return;
        parts.forEach(function (p) {
          p.vy += 0.22; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
          ctx.save();
          ctx.globalAlpha = Math.max(0, 1 - Math.max(0, t - 0.55) / 0.45);
          ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.fillStyle = p.c;
          ctx.beginPath();
          var r = Math.min(p.w, p.h) / 2;
          ctx.moveTo(-p.w / 2 + r, -p.h / 2);
          ctx.arcTo(p.w / 2, -p.h / 2, p.w / 2, p.h / 2, r);
          ctx.arcTo(p.w / 2, p.h / 2, -p.w / 2, p.h / 2, r);
          ctx.arcTo(-p.w / 2, p.h / 2, -p.w / 2, -p.h / 2, r);
          ctx.arcTo(-p.w / 2, -p.h / 2, p.w / 2, -p.h / 2, r);
          ctx.fill();
          ctx.restore();
        });
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    /* ---- Giro ---- */
    var spinning = false, done = false, rotation = 0, spinAnim = null;
    var resetTimer = 0;
    function scheduleReset(ms) { clearTimeout(resetTimer); resetTimer = setTimeout(resetForEdit, ms); }

    function spin() {
      if (spinning || done) return;
      if (!root.classList.contains('is-visible')) return;
      clearTimeout(resetTimer);
      spinning = true;
      eachSpin(function (b) { b.disabled = true; b.classList.remove('is-idle'); });
      root.classList.remove('is-idle');
      root.classList.add('is-spinning');

      var from = currentAngle(wheel);
      wheel.classList.remove('is-idle');
      wheel.classList.add('is-spinning');
      wheel.style.transform = 'rotate(' + from + 'deg)';

      var idx = pick();
      var center = idx * SEG + SEG / 2;
      var jitter = (Math.random() - 0.5) * SEG * 0.35;
      var toTop = (((POINTER - center - jitter) % 360) + 360) % 360;
      rotation = from + TURNS * 360 + ((toTop - from) % 360 + 360) % 360;

      var ms = (reducedMotion() ? 1.2 : SECONDS) * 1000;
      var finished = false;
      if (wheel.animate) {
        spinAnim = wheel.animate([{ transform: 'rotate(' + from + 'deg)' }, { transform: 'rotate(' + rotation + 'deg)' }], { duration: ms, easing: 'cubic-bezier(0.12, 0.72, 0.06, 1)', fill: 'forwards' });
        spinAnim.onfinish = finish;
      } else {
        wheel.style.transition = 'transform ' + ms + 'ms cubic-bezier(0.12, 0.72, 0.06, 1)';
        wheel.getBoundingClientRect();
        wheel.style.transform = 'rotate(' + rotation + 'deg)';
      }
      setTimeout(finish, ms + 400);
      lastIdx = sliceUnderPointer(from);
      cancelAnimationFrame(tickRaf);
      tickRaf = requestAnimationFrame(tickLoop);

      function finish() {
        if (finished) return;
        finished = true;
        cancelAnimationFrame(tickRaf);
        spinning = false;
        done = true;
        wheel.classList.remove('is-idle');
        wheel.classList.add('is-spinning');
        wheel.style.transition = '';
        wheel.style.transform = 'rotate(' + rotation + 'deg)';
        if (spinAnim) { try { spinAnim.cancel(); } catch (e) {} spinAnim = null; }
        [120, 600, 1500].forEach(function (dl) {
          setTimeout(function () {
            if (!done) return;
            wheel.classList.remove('is-idle');
            var diff = Math.abs((((currentAngle(wheel) - rotation) % 360) + 360) % 360);
            if (diff > 180) diff = 360 - diff;
            if (diff > 0.5) wheel.style.transform = 'rotate(' + rotation + 'deg)';
          }, dl);
        });

        var prize = prizes[idx] || {};
        /* o prêmio sorteado para na horizontal, embaixo do ponteiro: desvira para ler da esquerda para a direita */
        orienta(textoEls[idx], false);
        fatiaEls.forEach(function (f, k) { f.classList.toggle('is-winner', k === idx); });
        textoEls.forEach(function (t, k) { t.classList.toggle('is-winner', k === idx); });
        wheel.classList.add('is-settled');
        pointer.classList.add('is-bounce');
        setTimeout(function () { pointer.classList.remove('is-bounce'); }, 650);
        try { if (navigator.vibrate) navigator.vibrate([20, 40, 30]); } catch (e) {}
        burst();

        wonLabel.textContent = prize.label || ((prize.legenda || '') + ' ' + (prize.valor || ''));
        descEl.textContent = prize.desc || '';
        var hasCode = !!prize.code;
        codeEl.textContent = hasCode ? prize.code : '';
        if (codeStep) codeStep.hidden = !hasCode;
        if (noteStep) noteStep.hidden = !hasCode;
        if (hasCode) {
          var notaEl = noteStep ? noteStep.querySelector('.tp-rv2__note') : null;
          var notaOk = notaEl ? (notaEl.getAttribute('data-ok') || notaEl.textContent) : '';
          if (notaEl && !notaEl.getAttribute('data-ok')) notaEl.setAttribute('data-ok', notaOk);
          if (APPLY) {
            if (notaEl) notaEl.textContent = 'Aplicando o cupom no seu carrinho...';
            if (codeWrap) codeWrap.classList.remove('is-alerta');
            applyDiscount(prize.code).then(function (ok) {
              if (notaEl) notaEl.textContent = ok ? (notaOk || 'O cupom já fica aplicado ao seu carrinho.') : 'Não deu para aplicar sozinho — copie o código acima e use no carrinho.';
              if (!ok && codeWrap) codeWrap.classList.add('is-alerta');
            });
          } else if (notaEl) {
            notaEl.textContent = 'Copie o código acima e use no seu carrinho.';
          }
        }

        var temPresente = !!prize.presente;
        if (presenteStep) presenteStep.hidden = !temPresente;
        if (temPresente) {
          var nomePresente = prize.presenteTitulo || prize.label || 'Seu presente';
          if (presenteFoto) {
            if (prize.presenteFoto) { presenteFoto.src = prize.presenteFoto; presenteFoto.alt = nomePresente; presenteFoto.hidden = false; }
            else presenteFoto.hidden = true;
          }
          if (presenteNome) presenteNome.textContent = nomePresente;
          if (presenteNota) presenteNota.textContent = notaPresente(prize.presenteMinimo);
          premioSemTamanho = !!prize.presenteSemTamanho;
          premioAtual = prize;
          /* SEM E-MAIL (Black Antecipada): registra o presente na hora e abre o pop-up
             "presente ganho" 2 s depois, com a cliente já tendo lido o resultado. */
          liberaPresente(prize);
          setTimeout(function () { abrePremio(prize); }, 600);
        }
        root.classList.remove('is-spinning');
        root.classList.add('is-done');
        void result.offsetHeight;
        caberLogo();
        setTimeout(function () {
          root.classList.add('is-revealed');
          try { result.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest' }); } catch (e) {}
          if (ctaBtn) setTimeout(function () { try { ctaBtn.focus({ preventScroll: true }); } catch (e) {} }, 600);
        }, 40);
        rememberSpin({
          prize: prize.label || '', code: prize.code || '', desc: prize.desc || '',
          presente: prize.presente || '', presenteFoto: prize.presenteFoto || '', presenteTitulo: prize.presenteTitulo || '',
          presenteMinimo: prize.presenteMinimo || 0, presenteVariante: prize.presenteVariante || 0,
          presenteSemTamanho: !!prize.presenteSemTamanho, presenteValor: prize.presenteValor || 0,
          idx: idx
        });
        if (EDIT) scheduleReset(7000);
      }
    }

    function resetForEdit() {
      clearTimeout(resetTimer);
      if (spinning) return;
      done = false;
      eachSpin(function (b) { b.disabled = false; b.classList.add('is-idle'); });
      root.classList.remove('is-done', 'is-revealed', 'is-spinning');
      root.classList.add('is-idle');
      wheel.classList.remove('is-settled', 'is-spinning');
      wheel.style.transition = '';
      wheel.style.transform = '';
      wheel.classList.add('is-idle');
      fatiaEls.forEach(function (f) { f.classList.remove('is-winner'); });
      textoEls.forEach(function (t) { t.classList.remove('is-winner'); orienta(t, parseFloat(t.dataset.mid) > 180); });
    }

    /* Prende o cupom ao carrinho e devolve se deu certo (presença em discount_codes). */
    function applyDiscount(code) {
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' })
        .then(function () { return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var alvo = String(code).toUpperCase();
          return (c.discount_codes || []).some(function (dc) { return String(dc.code).toUpperCase() === alvo; });
        })
        .catch(function () { return false; });
    }

    /* A roleta REGISTRA o prêmio; quem põe e tira do carrinho é o tp-presente.js. */
    function liberaPresente(prize) {
      try { localStorage.removeItem('tp-roleta-pendente'); } catch (e) {}
      guardaPresente(prize.presente, prize.presenteMinimo, prize);
      atualizaTamanho();
    }
    function abrePremio(prize) {
      if (prize.presenteSemTamanho) { if (window.tpPresenteGanho) window.tpPresenteGanho.abrir(prize); return; }
      abreTamanho(0, 0);
    }
    /* O POP-UP DE TAMANHO ABRE SEMPRE (21/10/2026, Guilherme: "não podemos esperar que a cliente seja
       consciente e clique pra escolher o tamanho"). Antes: uma chamada só, que dependia de o
       tp-presente.js já existir e de a seção chegar pela rede. Agora: espera o script (até 6 s),
       pede para abrir e vigia por 1,8 s; se o pop-up não chegou a aparecer, pede de novo (3 vezes).
       Se apareceu e a cliente fechou, não insiste — o "Aproveitar agora" tranca sem tamanho. */
    function tamanhoNaTela() { var el = document.querySelector('[data-tp-presente-tamanho]'); return !!(el && !el.hidden); }
    function abreTamanho(espera, repete) {
      if (tamanhoEscolhido()) return;
      var pt = window.tpPresenteTamanho;
      if (!pt) { if (espera < 30) setTimeout(function () { abreTamanho(espera + 1, repete); }, 200); return; }
      pt.abrir();
      var viu = false, n = 0;
      var vigia = setInterval(function () {
        if (tamanhoNaTela()) viu = true;
        if (!viu && ++n < 6) return;
        clearInterval(vigia);
        if (!viu && repete < 3 && !tamanhoEscolhido() && root.classList.contains('is-visible')) abreTamanho(0, repete + 1);
      }, 300);
    }
    function guardaPresente(handle, minimo, prize) {
      try { localStorage.setItem('tp-roleta-presente', handle); } catch (e) {}
      try { localStorage.setItem('tp-roleta-presente-campanha', KEY); } catch (e) {}
      if (prize && prize.presenteSemTamanho && prize.presenteVariante) {
        try {
          localStorage.setItem('tp-roleta-presente-variante', String(prize.presenteVariante));
          localStorage.setItem('tp-roleta-presente-tamanho', 'unico');
        } catch (e) {}
      }
      try { localStorage.setItem('tp-roleta-presente-valor', String((prize && prize.presenteValor) || 0)); } catch (e) {}
      try { localStorage.setItem('tp-roleta-presente-minimo', String(Math.round((+minimo || 0) * 100))); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('tp:roleta-presente')); } catch (e) {}
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tp-roleta' }); } catch (e) {}
      }
    }

    /* ---- Aba lateral ---- */
    /* TRÊS TEXTOS (27/10/2026, Guilherme): não girou e fechou -> "Gire e ganhe!" (o texto que nasce no
       Liquid); girou e o presente tem tamanho ainda não escolhido -> "Escolha seu tamanho" (o clique já abre o
       pop-up de tamanho); girou -> "Veja seu presente". */
    var aba = root.parentNode ? root.parentNode.querySelector('[data-rv2-aba]') : null;
    var abaTexto = aba ? aba.querySelector('[data-rv2-aba-texto]') : null;
    function ganhouPresente() {
      return !!((premioAtual && premioAtual.presente) || (premioGuardado && premioGuardado.presente));
    }
    function faltaTamanho() { return ganhouPresente() && !presenteSemTamanho() && !tamanhoEscolhido(); }
    function rotuloAba(premio) {
      if (!aba || !premio) return;
      var alvo = faltaTamanho()
        ? (aba.dataset.abaTamanho || 'Escolha seu tamanho')
        : (aba.dataset.abaPremio || 'Veja seu presente');
      if (abaTexto) abaTexto.textContent = alvo;
      aba.setAttribute('aria-label', alvo);
    }
    document.addEventListener('tp:presente-tamanho', function () { if (done || premioGuardado) rotuloAba(true); });
    function mostraAba() { if (aba) aba.classList.add('is-on'); }
    function escondeAba() { if (aba) aba.classList.remove('is-on'); }
    aba && aba.addEventListener('click', function () {
      var pedirTamanho = (done || premioGuardado) && faltaTamanho();
      escondeAba();
      if (premioGuardado && !done) restauraPremio(premioGuardado);
      show();
      if (pedirTamanho) abreTamanho(0, 0);
    });

    /* Remonta o resultado a partir do que foi guardado, sem sortear nem reaplicar nada. */
    function restauraPremio(g) {
      done = true;
      spinning = false;
      wonLabel.textContent = g.prize || '';
      descEl.textContent = g.desc || '';
      var temCodigo = !!g.code;
      codeEl.textContent = temCodigo ? g.code : '';
      if (codeStep) codeStep.hidden = !temCodigo;
      if (noteStep) noteStep.hidden = !temCodigo;
      var temPresente = !!g.presente;
      if (presenteStep) presenteStep.hidden = !temPresente;
      if (temPresente) {
        var nome = g.presenteTitulo || g.prize || '';
        if (presenteFoto) {
          if (g.presenteFoto) { presenteFoto.src = g.presenteFoto; presenteFoto.alt = nome; presenteFoto.hidden = false; }
          else presenteFoto.hidden = true;
        }
        if (presenteNome) presenteNome.textContent = nome;
        if (presenteNota) presenteNota.textContent = notaPresente(g.presenteMinimo);
        premioSemTamanho = !!g.presenteSemTamanho;
        atualizaTamanho();
      }
      /* roda parada na fatia ganha, se soubermos qual foi */
      if (typeof g.idx === 'number' && g.idx >= 0 && g.idx < N) {
        var center = g.idx * SEG + SEG / 2;
        var ang = (((POINTER - center) % 360) + 360) % 360;
        wheel.style.transform = 'rotate(' + ang + 'deg)';
        orienta(textoEls[g.idx], false);
        fatiaEls.forEach(function (f, k) { f.classList.toggle('is-winner', k === g.idx); });
        textoEls.forEach(function (t, k) { t.classList.toggle('is-winner', k === g.idx); });
      }
      root.classList.remove('is-spinning', 'is-idle');
      root.classList.add('is-done', 'is-revealed');
      wheel.classList.remove('is-idle');
      wheel.classList.add('is-settled');
    }

    var lastFocus = null;
    function show() {
      escondeAba();
      /* APARECEU E NÃO GIROU = NÃO ABRE MAIS SOZINHA, SÓ PELA ABA (22/10/2026, Guilherme). O "já viu" é
         gravado na hora de APARECER, não só ao fechar: quem sai da página sem fechar também não vê a
         roleta abrir de novo. Quem girou guarda o prêmio por outro caminho (rememberSpin). */
      if (!done) rememberClose();
      lastFocus = document.activeElement;
      root.classList.remove('is-closing');
      root.classList.add('is-visible');
      document.documentElement.classList.add('tp-roleta-open', 'tp-rv2-open');
      /* Pré-carrega a seção do pop-up de tamanho: na hora do prêmio ela já está na página (21/10/2026). */
      try { if (window.tpPresenteTamanho && window.tpPresenteTamanho.preparar) window.tpPresenteTamanho.preparar(); } catch (e) {}
      caberLogo();
      requestAnimationFrame(caberLogo);
      setTimeout(function () { if (!spinning && !done) wheel.classList.add('is-idle'); }, 600);
      setTimeout(function () { try { spinBtn.focus({ preventScroll: true }); } catch (e) {} }, 350);
    }
    function hide() {
      if (!root.classList.contains('is-visible') || root.classList.contains('is-closing')) return;
      if (!done) rememberClose();
      root.classList.add('is-closing');
      var encolhe = !done && !reducedMotion();
      if (encolhe) root.classList.add('is-encolhendo');
      document.documentElement.classList.remove('tp-roleta-open', 'tp-rv2-open');
      setTimeout(function () {
        root.classList.remove('is-visible', 'is-closing', 'is-encolhendo');
        rotuloAba(done);
        mostraAba();
        try { lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); } catch (e) {}
        if (EDIT) {
          clearTimeout(resetTimer);
          setTimeout(function () {
            if (spinning || root.classList.contains('is-visible')) return;
            if (done) resetForEdit();
            show();
          }, 3000);
        }
      }, encolhe ? 520 : 230);
    }

    for (var c = 0; c < closeEls.length; c++) closeEls[c].addEventListener('click', hide);
    /* Fechou o pop-up "presente ganho": a roleta fecha junto e vira a aba "Veja seu prêmio". */
    document.addEventListener('tp-pg-fechou', function () {
      if (root.classList.contains('is-visible')) hide();
      else if (done) { rotuloAba(true); mostraAba(); }
    });

    /* iOS: cancela só o arrasto horizontal dentro do card. */
    (function () {
      var sx = 0, sy = 0, horiz = null;
      card.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; horiz = null;
      }, { passive: true });
      card.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        if (horiz === null) {
          var dx = Math.abs(e.touches[0].clientX - sx), dy = Math.abs(e.touches[0].clientY - sy);
          if (dx < 4 && dy < 4) return;
          horiz = dx > dy;
        }
        if (horiz && e.cancelable) e.preventDefault();
      }, { passive: false });
    })();
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-visible')) hide();
    });

    eachSpin(function (b) { b.addEventListener('click', spin); });
    wheel && wheel.addEventListener('click', spin);

    /* ---- Copiar cupom ---- */
    function copyCode() {
      var code = codeEl ? codeEl.textContent.trim() : '';
      if (!code) return;
      var original = copyBtn.textContent;
      function ok() {
        copyBtn.textContent = 'Copiado';
        codeWrap.classList.add('is-copied');
        setTimeout(function () { copyBtn.textContent = original; codeWrap.classList.remove('is-copied'); }, 2200);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); ok(); } catch (e) {}
        document.body.removeChild(ta);
      }
    }
    codeWrap && codeWrap.addEventListener('click', copyCode);
    codeWrap && codeWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyCode(); }
    });

    ctaBtn && ctaBtn.addEventListener('click', function () {
      /* Presente com tamanho e nenhum escolhido: a saída é escolher o tamanho, não ir embora (21/10/2026). */
      if (done && presenteStep && !presenteStep.hidden && !presenteSemTamanho() && !tamanhoEscolhido()) { abreTamanho(0, 0); return; }
      /* 22/10/2026 (Guilherme): sem URL própria, na HOME o "Aproveitar" leva para a coleção da Black
         (data-cta-home vem do Liquid só quando template = index); em coleção ou PDP, só fecha e fica onde está. */
      var url = (ctaBtn.dataset.url || '').trim() || (root.dataset.ctaHome || '').trim();
      if (url) { location.href = url; } else { hide(); }
    });

    /* Para a seção da oferta na coleção (e quem mais precisar) abrir a roleta. */
    window.tpRoletaV2 = {
      abrir: function () { if (premioGuardado && !done) restauraPremio(premioGuardado); show(); },
      ganhou: function () { return !!premioGuardado || done; }
    };

    /* Quem já ganhou não vê o pop-up abrir sozinho -- só a aba. */
    if (premioGuardado) {
      rotuloAba(true);
      mostraAba();
    }
    else if (fechouAntes) mostraAba();
    else if (DELAY > 0) setTimeout(show, DELAY);
    else show();

    /* Sem e-mail nesta roleta: qualquer "pendente de e-mail" de campanha antiga sai. */
    try { localStorage.removeItem('tp-roleta-pendente'); } catch (e) {}
  }

  function boot() {
    var roots = document.querySelectorAll('[data-tp-rv2]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
